import { ForwardedRef, forwardRef } from 'react';
import { clsx } from 'clsx';
import { IJxtDropdownItem } from './types';

const JxtDropdownItem = (
  { children, className, ...rest }: IJxtDropdownItem,
  ref: ForwardedRef<HTMLButtonElement>
) => {
  return (
    <button
      {...rest}
      ref={ref}
      type="button"
      className={clsx('h-10 w-full px-4 py-2 text-body-m text-neutral-140 hover:bg-neutral-10 text-left cursor-pointer', className)}
    >
      {children}
    </button>
  );
};

export default forwardRef(JxtDropdownItem);
